import isEmpty from 'lodash/isEmpty';
import { PermissionLevel } from '../enums/permissionLevel';

export const isUserAuthorized = userInfo => {
  if (isEmpty(userInfo)) {
    return false;
  }
  const { permissionLevel, idToken, user } = userInfo;
  return !isEmpty(permissionLevel) && !isEmpty(idToken) && !isEmpty(user);
};

export const isAdminUser = userInfo => {
  if (isEmpty(userInfo)) {
    return false;
  }
  const { permissionLevel } = userInfo;
  return permissionLevel === PermissionLevel.ADMIN;
};

export const isHRUser = userInfo => {
  if (isEmpty(userInfo)) {
    return false;
  }
  const { permissionLevel } = userInfo;
  return permissionLevel === PermissionLevel.HRBP;
};
